import type { TransactionExecutionError, TransactionReceipt } from "viem";
import { PostHogAction, PostHogEvent } from "@/posthog/posthog-capture-names";
import posthog from "posthog-js";

export const usePostHogCaptureTx = () => {
    const wrap = async (tx: Promise<TransactionReceipt>): Promise<TransactionReceipt> => {
        const receipt = await tx
            .then((txRes) => {
                // Capture the transaction event with PostHog
                posthog.capture(PostHogEvent.Wallet.transactionInitiated, {
                    txHash: txRes.transactionHash,
                    action: PostHogAction[PostHogEvent.Wallet.transactionInitiated],
                });
                return txRes;
            })
            .catch((error: TransactionExecutionError) => {
                // Handle error if needed
                posthog.captureException(error, { context: "Transaction Execution" });
                throw error;
            });
        return receipt;
    };

    return { wrap };
};
